import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=903eaad2&scoped=true"
import script from "./pageBanner.vue?vue&type=script&lang=js"
export * from "./pageBanner.vue?vue&type=script&lang=js"
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=903eaad2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903eaad2",
  null
  
)

export default component.exports